export { default as CoreTabsContainer } from './Tabs';
